import { Button, Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography, Avatar, Stack } from '@mui/material';
import { Trash01 } from '../../../assets';
import useNswagClient from '../../../hooks/api/useNswagClient';
import { useTranslation } from 'react-i18next';
import useLogError from '../../../hooks/useLogError';
import CloseIcon from '@mui/icons-material/Close';
import { theme } from '../../../theme';   

export interface Reports  {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  reportId: number ;
  name: string | undefined;
 } 

const DeleteReport=( props: Reports) => {
  const { deleteReport } = useNswagClient();
  const { logError } = useLogError();
  const { t } = useTranslation('reportBuilder');
 
  const confirmDeleteReport = () => {
    deleteReport(props.reportId).then(() => {
      props.onConfirm();
    })
      .catch((error) => {
        logError(error);
      });
  };
 
  return (  
    <Dialog
      fullWidth
      maxWidth='sm'
      open={props.open}
      onClose={() => props.onClose()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        '& .MuiDialog-container': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }}>
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Avatar
            sx={{
              backgroundColor: () => theme.palette.error[100],
              color: () => theme.palette.error[700],
            }}
          > 
            <Trash01 color={theme.palette.error[500]} />
          </Avatar>
        </Box>
        <IconButton
          onClick={props.onClose}
          sx={{
            color: (theme) => theme.palette.custom.gray[800],
            mr: '-10px',
          }}
        >
          <CloseIcon />
        </IconButton> 
      </DialogTitle>
      <DialogContent>
        <Stack>
          <Typography variant='textLG'
            fontWeight={600}>  {t('deleteReport')}</Typography>
          <Typography color="textSecondary"
            sx={{ mt: 1, whiteSpace: 'pre-line' }}
            variant="textSM">
            {t('deleteReportConfirm', { reportName: props.name })}
          </Typography> 
        </Stack>
      </DialogContent>
      <DialogActions sx={{
        padding: '0px 24px 24px',
        '&.MuiDialogActions-root': {
          padding: '0px 24px 24px',
        },
      }}>
        <Stack direction={{ xs: 'column', md: 'row' }}
          gap='12px'
          width='100%'>
          <Button
            fullWidth
            variant="secondary"
            size="md"
            sx={{ fontSize: '16px' }} 
            onClick={props.onClose}>
            {t('close')}
          </Button>
          <Button
                    
            fullWidth
            variant="bad"
            size="md"
            sx={{ fontSize: '16px' }} 
            onClick={confirmDeleteReport}
          >
            {t('delete')}
          </Button>

        </Stack>
      </DialogActions> 

    </Dialog>
     
  );
};

export default DeleteReport;